import React from "react";
import { Link } from "react-router-dom";
import localeText from "../../../../locale";
import "./ManagerDashboardFooter.css";
import { useThemeContext } from "../../../../contexts/ThemeContext/ThemeContext";

const ManagerDashboardFooter = ({ userTypeInfo }) => {
  const { subnetInfo } = useThemeContext();
  const showBusinessSquare = userTypeInfo === "Manager" && !!subnetInfo;
  const rawOwnerAddress = subnetInfo?.ownerAddress;
  const ownerAddress = typeof rawOwnerAddress === "string" ? rawOwnerAddress.trim() : "";
  const hasInvalidOwnerAddress =
    !ownerAddress || /postal code:\s*null/i.test(ownerAddress) || /^null\s*,/i.test(ownerAddress);
  const businessSquareAddress = hasInvalidOwnerAddress ? "" : ownerAddress;

  const rawOwnerTelephone = subnetInfo?.ownerTelephone;
  const ownerTelephone =
    typeof rawOwnerTelephone === "string"
      ? rawOwnerTelephone.replace(/^\s*(null)+/i, "").trim()
      : "";

  return (
    <footer className="manager-dashboard-footer mt-5 pb-0">
      <div className="manager-dashboard-footer__content">
        <div className="manager-dashboard-footer__company">
          <div>{showBusinessSquare ? subnetInfo?.name : "Extraconomy Global srl"}</div>
          {showBusinessSquare ? (
            businessSquareAddress ? (
              <div>{businessSquareAddress}</div>
            ) : null
          ) : (
            <div>Via Nomentana, 1018 - 00137 Roma (IT)</div>
          )}
        </div>
        {showBusinessSquare && (
          <>
            <div className="manager-dashboard-footer__tax">
              {ownerTelephone ? `${ownerTelephone} | ` : ""}
              {subnetInfo?.ownerEmail}
            </div>
          </>
        )}
        <div className="manager-dashboard-footer__privacy">
          <Link to="/privacy" className="manager-dashboard-footer__link">
            {localeText("privacyPolicy")}
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default ManagerDashboardFooter;
